var app = angular.module("leonardo");

var MainMenuController = function($scope, $state, $rootScope, FilterService, QuickReportsService, ReportService,
                                  AuthDataService, PermissionService, AccountUserService, AccountService, blockUI, StatsigService, AccountUserRoleService) {

  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;
  $scope.accountUser = AuthDataService.authData.account ? AuthDataService.authData.account.id : null;

  $scope.report_types = ReportService.TYPE_OPTIONS;

  $scope.filterService = FilterService;


  if (AuthDataService.isAdmin() || PermissionService.permissionAvailableAdmin('permission_view_reports')) {
    QuickReportsService.getlist({only_superuser: 1, menu_item: 'administrative_report'}, true).then(function (data) {
      $scope.quick_administrative_reports = data.results ? data.results : data;
    });
  }

  $scope.redirectToEnvoyLink = function() {
    if (AuthDataService.authData && AuthDataService.authData.account && AuthDataService.authData.account.id) {
      var redirectUrl = window.LEO_ENVOY_ADMIN_URL + '?i=' + AuthDataService.authData.account.id + '&t=' + localStorage.getItem('jwt_token');
      window.open(redirectUrl, '_blank');
    }else{
      NotificationService.error('Account is not found');
    }
}

  $scope.goToReport = function (report_type) {
    if ((report_type !== '') && (report_type !== null) && (report_type !== undefined)) {
      switch (report_type.toString()) {
        case ReportService.TYPE_ACTION_ITEM :
          $state.go('administrative-reports.action-item');
          break;
        case ReportService.TYPE_ACTIVITY :
          $state.go('administrative-reports.activity');
          break;
        case ReportService.TYPE_UNIT:
          $state.go('administrative-reports.unit');
          break;
        case ReportService.TYPE_WORKFLOW:
          $state.go('administrative-reports.workflow');
          break;
        case ReportService.TYPE_DYNAMIC_FORM:
          $state.go('administrative-reports.dynamic');
          break;
        case ReportService.TYPE_BILLING:
          $state.go('administrative-reports.billing');
          break;
        case ReportService.TYPE_TEMPLATE:
          $state.go('administrative-reports.template');
          break;
        case ReportService.TYPE_PROPERTY:
          $state.go('administrative-reports.property');
          break;
        case ReportService.TYPE_USER:
          $state.go('administrative-reports.user');
          break;
        default:
          $state.go('administrative-reports.action-item');
          break;
      }
    }
  };

  $scope.quickReport = function(report){
    var filters = angular.copy(FilterService.filters);
    angular.forEach(filters, function(value, key){
      if (!_.contains(['portfolio', 'property'], key)){
        FilterService.removeFilter(key, true);
      }
    });
    if (report.only_superuser) {
      FilterService.setFilter('only_superuser', report.only_superuser, true);
    }
    angular.forEach(report.filters, function(value, key) {
      if (angular.isArray(value) && (key !== 'dynamic_filters'))
        value = value.join(',');
      if ((value !== undefined) && (value !== null) && (value !== '') && (value.length != 0))
        switch (key) {
          case 'portfolio':
            FilterService.setFilter('portfolio_reports', value, true);
            break;
          case 'property':
            FilterService.setFilter('property_reports', value, true);
            break;
          case 'unit_type':
            FilterService.setFilter('unit__unit_type', value, true);
            break;
          default :
            FilterService.setFilter(key, value, true);
            break;
        }
    });
    var direct_filters = [];
    angular.forEach(report.direct_filters, function(value, key) {
      direct_filters.push(key);
    });
    if (direct_filters.length > 0) {
      FilterService.setFilter('direct_filters', direct_filters.join(','), true);
    }
    ReportService.setTitleQuick(report.name);
    ReportService.setQuickReport(report);
    var type = report.report_type ? report.report_type.toString() : report.report_type;
    $scope.goToReport(type);
  };

  $scope.toggleMenu = function(event){
    if (angular.element(event.target).parent().hasClass('active')) {
      event.preventDefault();
    }
    angular.element(event.target).parent().toggleClass('active');
  };

  $scope.canSeeDashboard = function () {
    return (
      FilterService.properties.length > 0 &&
      (AuthDataService.isAdmin() || PermissionService.permissionAvailable('permission_view_thoughtspot_reporting'))
    );
  };


  blockUI.done(function(){
    $rootScope.$broadcast('init-snapper');
  });

};

app.controller('MainMenuController', ['$scope', '$state', '$rootScope', 'FilterService', 'QuickReportsService',
  'ReportService', 'AuthDataService', 'PermissionService', 'AccountUserService', 'AccountService', 'blockUI', 'StatsigService', 'AccountUserRoleService',
  MainMenuController]);